import { Injectable } from '@angular/core';
import { topicId } from '../messaging-subscription.model';
import { Topic } from '../messaging-subscription.service';
import { TopicStorage } from './topic-storage.api';

const SUBSCRIBTIONS_LOCAL_STORAGE_KEY = 'messagingSubscribtions';

@Injectable()
export class LocalStorageTopicStorage implements TopicStorage {
  saveTopic(topic: Topic): void {
    const subscribtions: Record<string, Topic> = this.read();
    subscribtions[topicId(topic)] = { type: topic.type, entityId: topic.entityId };
    this.write(subscribtions);
  }

  deleteTopic(topic: Topic): void {
    const subscribtions: Record<string, Topic> = this.read();
    delete subscribtions[topicId(topic)];
    this.write(subscribtions);
  }

  getAllSubscribedTopics(): Topic[] {
    const subscribtions: Record<string, Topic> = this.read();
    return Object.values(subscribtions);
  }

  private read(): Record<string, Topic> {
    const subscribtionsStr = localStorage.getItem(SUBSCRIBTIONS_LOCAL_STORAGE_KEY);
    return subscribtionsStr ? JSON.parse(subscribtionsStr) : {};
  }

  private write(topics: Record<string, Topic>) {
    localStorage.setItem(SUBSCRIBTIONS_LOCAL_STORAGE_KEY, JSON.stringify(topics));
  }
}
